export default __webpack_public_path__ + "static/media/Mark-2-HUD-Pop-Up (Process).e2fc6c78.jpg";